import { Question } from './Question';
import { DemographicOptionsViewModel } from './DemographicOptionsViewModel';

export class SurveyAssessmentViewModel {
    public name: string;
    public surveyID: number;
    public surveyInstanceUniqueID: string;
    public questions: Question[];
    public completedDate: Date;
    public expired: boolean;

    public demographicOptions: DemographicOptionsViewModel;

    constructor() {
        this.questions = [];
    }
}


// WEBPACK FOOTER //
// ./src/models/SurveyAssessmentViewModel.tsx